import React, {useEffect} from 'react';
import {Button, Input, VStack} from '@chakra-ui/react';
import {useForm} from '@/uses/useForm';
import {useApi} from '@/uses/useApi';
import {Field} from "@/components";
import {useLanguage} from "@/contexts/languageContext";

/** Codes d'erreur renvoyés par l'API pour le libellé */
export const getLabelError = (error, t) => {
    switch (error) {
        case undefined:
        case null:
            return undefined;
        case 'ALREADY_EXISTS':
            return t('errors.labelAlreadyExists');
        case 'MISSING_FIELD':
            return t('errors.pleaseFillField');
        default:
            return error;
    }
};

export const CreateOrEditDivision = (props) => {
    const divisionId = props?.id;
    const {t} = useLanguage();
    const api = useApi();
    const {formData, formFieldErrors, handleInputChange, handleInputChanges, handleFormSubmit} = useForm(
        {label: ''},
        {
            label: {
                required: {value: true, message: t('errors.pleaseFillField')},
            },
        }
    );

    /** La ligne de la liste contient déjà toutes les données de la division */
    useEffect(() => {
        if (divisionId) {
            handleInputChanges({label: props?.label ?? ''});
        }
    }, [divisionId]);

    return (
        <VStack h="100%" overflow="hidden" p="1.5rem 0" gap="5vh" w="100%">
            <VStack flex={1} gap="5" p="5" w="100%" align="center" justify="flex-start">
                <Field
                    label={t('wrappers.mandatoryLabel', {value: t('fields.label')})}
                    errors={getLabelError(formFieldErrors.label, t)}
                    maxW="40rem"
                >
                    <Input
                        value={formData.label}
                        onChange={(e) => handleInputChange('label', e?.target?.value ?? '')}
                        placeholder={t('fields.division')}
                    />
                </Field>
            </VStack>
            <Button
                variant="primary"
                mt="auto"
                height="auto"
                borderRadius=".5rem"
                style={{padding: '1rem 1.5rem'}}
                onClick={() => handleFormSubmit(async (data) => {
                    if (divisionId) {
                        return api.ApiService.update('division', divisionId, data);
                    }
                    return api.ApiService.create('division', data);
                }, props?.successCallback)}
            >
                {t('actions.validate')}
            </Button>
        </VStack>
    );
};

export default CreateOrEditDivision;
